import React from 'react';
import { Button, Space, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { theme } from '../../../theme';

interface ContratoFormActionsProps {
  loading: boolean;
  hasUnsavedChanges: boolean;
  onSave: () => void;
  onSaveAndNew: () => void;
  onCancel: () => void;
}

export const ContratoFormActions: React.FC<ContratoFormActionsProps> = ({
  loading,
  hasUnsavedChanges,
  onSave,
  onSaveAndNew,
  onCancel
}) => {
  const handleCancel = () => {
    if (hasUnsavedChanges) {
      Modal.confirm({
        title: '¿Descartar cambios?',
        icon: <ExclamationCircleOutlined />,
        content: 'Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
        okText: 'Sí, descartar',
        cancelText: 'Cancelar',
        okType: 'danger',
        onOk: () => {
          onCancel();
        }
      });
    } else {
      onCancel();
    }
  };

  return (
    <div style={{ marginTop: '24px', textAlign: 'center', borderTop: `1px solid ${theme.colors.borderLight}`, paddingTop: '16px' }}>
      <Space size="middle">
        <Button
          onClick={handleCancel}
          disabled={loading}
          size="small"
        >
          Cancelar
        </Button>
        <Button
          type="primary"
          onClick={onSave}
          loading={loading}
          size="small"
          style={{ backgroundColor: theme.colors.primary, borderColor: theme.colors.primary }}
        >
          Guardar
        </Button>
        <Button
          type="primary"
          onClick={onSaveAndNew}
          loading={loading}
          size="small"
          style={{ backgroundColor: theme.colors.success, borderColor: theme.colors.success }}
        >
          Guardar y Nuevo
        </Button>
      </Space>
    </div>
  );
};

